"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoAvailabilitySupport = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@monument/core");
var _useNoAvailabilitySupport = require("./useNoAvailabilitySupport");
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NoAvailabilitySupport = function NoAvailabilitySupport(props) {
  var _useAuth = (0, _core.useAuth)(),
    user = _useAuth.user;
  return (0, _core.isPatient)(user) ? /*#__PURE__*/_react.default.createElement(PatientVersion, props) : (0, _core.isAdmin)(user) ? /*#__PURE__*/_react.default.createElement(AdminVersion, null) : /*#__PURE__*/_react.default.createElement(ClinicianVersion, null);
};
exports.NoAvailabilitySupport = NoAvailabilitySupport;
var PatientVersion = function PatientVersion(_ref) {
  var clinicianType = _ref.clinicianType,
    confirmText = _ref.confirmText,
    _ref$handleConfirm = _ref.handleConfirm,
    handleConfirm = _ref$handleConfirm === void 0 ? _core.noop : _ref$handleConfirm,
    _ref$handleDecline = _ref.handleDecline,
    handleDecline = _ref$handleDecline === void 0 ? _core.noop : _ref$handleDecline;
  var lowerCaseUserRole = (0, _core.getRoleNameLower)(clinicianType);
  var _useNoAvailabilitySup = (0, _useNoAvailabilitySupport.useNoAvailabilitySupport)([clinicianType], handleConfirm, handleDecline),
    hasSubmittedTicket = _useNoAvailabilitySup.hasSubmittedTicket,
    confirmNoAvailability = _useNoAvailabilitySup.handleConfirm,
    loading = _useNoAvailabilitySup.loading;
  var defaultConfirmText = "There aren\u2019t any available ".concat(lowerCaseUserRole, "s at this time. Would you like to be notified when we have available ").concat(lowerCaseUserRole, "s?");
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-[24px]"
  }, confirmText || defaultConfirmText), /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
    name: "submit-support-ticket",
    type: "dark",
    disabled: hasSubmittedTicket || loading,
    checked: hasSubmittedTicket,
    onChange: function onChange(e) {
      if (e.target.checked && !hasSubmittedTicket) {
        confirmNoAvailability();
      }
    }
  }, "Please email me when appointments become available"));
};
var ClinicianVersion = function ClinicianVersion() {
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-[54px]"
  }, "There are no available appointment times. Please", ' ', /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/availability/manage"
  }, "update your availability"), " in order to book appointments.");
};
var AdminVersion = function AdminVersion() {
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-[54px]"
  }, "This clinician does not have available appointment times. Please update their availability in order to book appointments.");
};